import { BRAND_GROUPS_UPDATE } from "constants/action-types";

export const updateGroups = (groups) => ({
    payload: groups,
    type: BRAND_GROUPS_UPDATE,
});
